export const ADD_MAIN_MODULE = 'ADD_MAIN_MODULE';
type UserActionType = typeof ADD_MAIN_MODULE;
export interface UserAction {
  type: UserActionType;
  payload: any;
}
export interface UserActionRequest {
  mainModuleId: string;

}
export interface Client{
  id:string;
  dni:string;
  firsName:string,
  secondName:string| null,
  lastName:string,
  secondLastName:string| null,
  fullName:string,
  createdAt:string,
  updatedAt:string| null,
  email:string,
  status:string| null,
  password:string,
  cellPhone:string| null,
}
export interface ClientResponse{
  FullName:string,
  Email :string, 
  Dni:string, 
  Status: string, 

}
export interface MainModuleDataType {
  id: string;
  key: string;
  label: string;
  url: string;
  icon: string;
  xTenant: string;
  urlModule: string;
  rolId: string;
  portal:boolean;
  created_at: Date;
  description:string;
}
export interface LoginDTO{
  email:String,
  password:string
}
export interface UserRequest
  {
      dni:string| null;
      firstName:string;
      secondName:string| null;
      lastName:string;
      secondLastName:string| null;
      email:string;
      password:string;
      cellPhone:string| null;
  }